import { Exam } from '@/interfaces/exam';
import { EntityResource } from './entity.resource';

export class ExamResource extends EntityResource<Exam> {
  protected getFields = {
    id: true,
    name: true,
    unit: true,
    sport: {
      id: true,
      name: true
    },
    sportId: true,
    club: {
      id: true,
      name: true
    },
    team: {
      id: true,
      name: true
    }
  };

  protected listFields = {
    id: true,
    name: true,
    unit: true,
    sport: {
      id: true,
      name: true
    }
  };

  protected listVariables = { filters: 'ExamFilters' };

  constructor() {
    super({ entityName: 'exam' });
  }
}

export const examResource = new ExamResource();
